export interface Feature {
  id: number;
  key: FeatureKey;
}

export enum FeatureKey {
  TableOrder = 'table_order',
  SquarePayment = 'square_payment',
  Hms = 'hms',
  Outlet = 'outlet',
  FoodingJournal = 'fooding_journal',
  ChatAssistant = 'chat_assistant',
  HmsImportReceipt = 'hms_import_receipt',
}

export interface FeatureListResponse extends PaginatedResponse<Feature> {}
